import store from '../store';

export const getCommonCodeLabel = (commonCode: string, detailCode: string = '', lng: string) => {
  const commonCodes = store.getState().commonCode.commonCodes;
  const commonCodeObj = commonCodes?.find((item: { commonCode: string; }) => item.commonCode === commonCode);
  const detailCodeObj = commonCodeObj?.detailCode?.find((item: { detailCode: string; }) => item.detailCode === detailCode);
  const label = detailCodeObj
    ? lng === 'ko'
      ? detailCodeObj.korName
      : detailCodeObj.engName
    : detailCode

  return label;
}
